export default __webpack_public_path__ + "static/media/phone-solid.5bb54acd.svg";